import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';

import * as moment from 'moment-timezone';

import { Usuario } from '../Models/Usuario';

@Injectable()
export class UtilesService {

  constructor(private storage: LocalStorageService) { }

  usuarioActivo(): Usuario {

    if (this.storage.retrieve('sesion') === null) {
      return;
    }

    return JSON.parse(atob(this.storage.retrieve('sesion')));
  }

  /**
   * Limpia la sesion
   */
  limpiarLogin() {
    this.storage.clear('sesion');
  }

  NumeroVersion(): String {

    // tslint:disable-next-line:quotemark
    return "1.0.0.1";
  }

  getURL(metodo: string): string {

    // desarrollo
    // return "http://cto/dtsapi/api/" + metodo;

    // return "http://192.168.1.154:52013/api/" + metodo;

    // return "http://192.168.1.126/dtsapi/api/" + metodo;

    // DTS PRESENTACION
    // return "http://192.168.1.126:9093/api/api/" + metodo;

    // AZURE DTS SANDAL
    // return "http://192.168.1.126:8082/DTS_API/api/" + metodo;

    // azure Purdy Moror
     return "https://dtsapi20180529063249.azurewebsites.net/api/" + metodo;

    // ALPISTE PRUEBAS
    //  return "http://137.135.102.246:9190/dtsapi/api/" + metodo;

    // ALPISTE PRODUCCION

    // return "https://dts.alpiste.co.cr/dtsapi/api/" + metodo;

    // SANDAL AZURE PRODUCCION

    // return "https://dtsapisandal.azurewebsites.net/api/" + metodo;


    // ip publica
    // return "http://167.250.193.24/dtsapi/api/" + metodo;

    // azure pruebas showroom
    // return "http://dtsapishowroom.azurewebsites.net/api/" + metodo;

    // COFERSA PRODUCCION
    // return "http://190.0.1.225:9595/dtsapi/api/" + metodo;
    // return "http://dts.cofersa.net:9595/dtsapi/api/" + metodo;
  }




  getURLReportes(): string {

    // desarrollo
    // return 'http://localhost/dtsarchivos/';
    // return 'http://dts.alpiste.co.cr:9595/dtsarchivos/';
    return 'https://dts.alpiste.co.cr:9595/dtsarchivos/';
    // return 'http://192.168.0.9:9595/dtsarchivos/';
  }

  unionFechaHora(fecha: any, hora: number, minuto: number, segundo: number): Date {


    // let fecha=new Date()

    const cadena: string[] = fecha.split("-");
    const anno = parseInt(cadena[0], 0);
    const mes = parseInt(cadena[1], 2);
    const dia = parseInt(cadena[2].substring(0, 2), 2);
    let fechaConvertida: string;
    fechaConvertida = anno + "-" + mes + "-" + dia + " 22:59:59";
    console.log(moment().tz(fechaConvertida, "Europe/Paris").format());
    // return new Date(moment.tz(cadena, "America/Costa_Rica").format());

    return new Date(moment().tz(fechaConvertida, "America/Costa_Rica").format());

  }

  getEscapeString(_String: string) {
    return encodeURIComponent(_String);
  }

}
